import { render } from "./Sidebar.vue?vue&type=template&id=f7d4731a"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=f7d4731a&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__